import { useEffect, useMemo, useState } from "react";
import { Modal } from "reactstrap";
import styles from './CategoryForm.module.scss';
import { GADimensions, GAEvents, MetricValueType, PnlCategoryNames, PnlFsNames, TypeOfAmount, TypeOfFinanceOption, formActionTypes } from "../../../interfaces/interfaces";
import { AiOutlineClose as CloseIcon } from "react-icons/ai";
import OutlinedFormInput from "../components/OutlinedFormInput/OutlinedFormInput";
import { Field, Form } from "react-final-form";
import MeritoRadioButton from "../components/RadioButton/MeritoRadioButton";
import { OnChange } from 'react-final-form-listeners'
import MeritoButton from "../../../components/common/MeritoButtons/MeritoButtons";
import ReportSearchBar, { SearchBarType } from "../../ReportDetails/Components/ReportHeader/reportSearch/ReportSearchBar";
import Select, { components } from 'react-select';
import SelectMetric from "../components/SelectMetric/SelectMetric";
import SelectMetricCustom from "../components/SelectMetric/SelectMetricCustom";
import { GASendEvent, formatNumberWithComma, getLast12CYMonthsArr, getLocalUser, onBlurFormatNumber, parseNumberForDB, setFieldTouchedMutator } from "../../../components/functions/utilities";
import moment from 'moment';
import arrayMutators from 'final-form-arrays'
import { FieldArray } from 'react-final-form-arrays'
import MeritoCheckbox from "../components/CustomCheckbox/MeritoCheckbox";
import { RestS } from "../../../rest/rest-service";
import CircularLoader from "../../../components/common/CircularLoader/CircularLoader";
import { reqiredValidation } from "../../../components/functions/formValidation";
import CategoryFormErrorFieldContainer from "./ErrorFieldContainer";
import { OverlayTrigger } from "react-bootstrap";
import { RenderTooltip } from "../../../components/common/RenderTooltip";
import { LiaUserEditSolid } from "react-icons/lia";
import { AiOutlineDelete } from "react-icons/ai";
import ConfirmDialog from "../../../components/common/ConfirmDialog";
import { FaCircleExclamation as Exclamation } from "react-icons/fa6";
import { GrUndo as UndoIcon } from "react-icons/gr";
import { RiDeleteBin6Line as DeleteIcon } from 'react-icons/ri';
import CurrencyInput from 'react-currency-input-field';




type Props = {
  isOpen: boolean;
  setOpen: (value: boolean) => void,
  closeForm: (fetchTabs?: boolean) => void,
  actionType: formActionTypes,
  categoryId: number,
  categoryName: string,
  metricOptions: {
    id: number;
    label: string;
    type: TypeOfFinanceOption,
    value: string;
  }[],
  monthLabels: string[];
  formMetricId: number;
  ipConfigs: { [x: string]: string },
  financeStatementOptions: any,
  financeStatmentId: number,
  formHeaderTitle?: {
    editTitle: string,
    addTitle: string,
  },
}




const CategoryForm = ({ isOpen, setOpen, actionType, categoryName, metricOptions, monthLabels, formMetricId, closeForm, categoryId, ipConfigs, financeStatementOptions, financeStatmentId, formHeaderTitle = null }: Props) => {
  const [initialValues, setInitialValues] = useState({});
  const [loading, setLoading] = useState(false);
  const { id: userId } = getLocalUser();
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [deleteBtnLoading, setDeleteBtnLoading] = useState(false);
  const [percentageIsDirty, setPercentageIsDirty] = useState(false);
  let user = getLocalUser();
  // console.log('metricOptions', metricOptions);
  // const [initialPercentage, setInitialPercentage] = useState(false);


  const financeMetricsEditValues = async () => {


    try {
      setLoading(true);
      const data: any = await RestS.getFinanceMetricsEditData(formMetricId);
      console.log('editValues', data);
      const inputDataObj = data?.inputData ? data?.inputData.reduce((prev, curVal) => {
        prev[curVal.monthYear] = curVal;
        return prev;
      }, {}) : {};
      const monthSet = new Set();
      const integrationPartner = data?.dataSource && data?.dataSource.length ? data?.dataSource[0] : null;

      const relationMetric = {
        metricId: data?.scheduledCosts && data?.scheduledCosts['isPercentage'] ? data?.scheduledCosts['relationMetricId'] : null,
        relationType: data?.scheduledCosts && data?.scheduledCosts['isPercentage'] ? data?.scheduledCosts['relationType'] : null,
      };

      // console.log("relationMetric", relationMetric);
      const selectedMetricOption = formattedOptions.filter((item) => {
        if (item.id == relationMetric?.metricId && item.type == relationMetric?.relationType) {
          return true;
        } else {
          return false;
        }
      });

      // console.log('selectedMetricOpton', selectedMetricOption)

      console.log('inputDataObj', inputDataObj)

      const typeOfAmount = data?.scheduledCosts && data?.scheduledCosts['isPercentage'] ? TypeOfAmount.percentage : TypeOfAmount.fixed;
      let isAllPercentage = true;
      let metricIdOption = null;
      const formattedInitialValues = {
        metricName: data?.feMetricName,
        apiAvailable: data?.apiAvailable,
        fixedAmountValue: data?.scheduledCosts && !data?.scheduledCosts['isPercentage'] ? data?.scheduledCosts['value'] : null,
        fixedPercentageValue: data?.scheduledCosts && data?.scheduledCosts['isPercentage'] ? data?.scheduledCosts['value'] : null,
        typeOfAmount: typeOfAmount,
        isUserAdded: data?.isUserAdded,
        selectedMetric: selectedMetricOption?.length > 0 ? selectedMetricOption[0] : null,
        integrationPartner: integrationPartner,
        setForFutureMonths: data?.scheduledCosts ? true : false,
        months: monthLabels.map((item, index) => {
          const momentYear = moment(item, "MM-YYYY").format("YYYY");
          let outputObj = null;

          if (inputDataObj[item] != undefined) {
            const currentObj = inputDataObj[item];
            const currentCost = currentObj?.inEffectValue == MetricValueType.apiCost ? currentObj?.apiCost : currentObj?.updatedCost;
            if (!currentObj?.isPercentage) {
              isAllPercentage = false;
            }
            metricIdOption = currentObj?.relationMetricId ? {
              metricId: currentObj?.relationMetricId,
              type: currentObj?.relationType
            } : metricIdOption;
            outputObj = {
              label: item,
              value: currentObj?.isPercentage ? currentObj?.percentageValue : currentCost,
              percentageValue: currentObj?.percentageValue,
              editedBy: currentObj?.editedBy,
              editedByName: currentObj.editedByName,
              editedTime: currentObj?.editedTime,
              isPercentage: currentObj?.isPercentage,
              apiCost: currentObj?.apiCost,
              updatedCost: currentObj?.updatedCost,
              inEffectValue: currentObj?.inEffectValue,
              isSeparator: monthSet.size > 0 && !monthSet.has(momentYear) ? true : false,
            }
          } else {
            isAllPercentage = false;
            outputObj = {
              label: item,
              value: '',
              editedBy: null,
              editedByName: null,
              editedTime: null,
              isPercentage: typeOfAmount == TypeOfAmount.percentage ? true : false,
              apiCost: 0,
              updatedCost: 0,
              inEffectValue: MetricValueType.updatedCost,
              percentageValue: null,
              isSeparator: monthSet.size > 0 && !monthSet.has(momentYear) ? true : false,
            }
          }
          monthSet.add(momentYear);
          return outputObj;
        })
      }

      formattedInitialValues.typeOfAmount = isAllPercentage ? TypeOfAmount.percentage : formattedInitialValues.typeOfAmount;
      // if(selectedMetric)
      if (!formattedInitialValues?.selectedMetric && isAllPercentage) {
        if (metricIdOption) {
          const backupOption = formattedOptions.filter((item) => {
            if (item.id == metricIdOption?.metricId && item.type == metricIdOption?.type) {
              return true;
            } else {
              return false;
            }
          })
          if (backupOption.length) {
            formattedInitialValues.selectedMetric = backupOption[0];
          }
        }

      }
      console.log('initialValues', formattedInitialValues);
      setInitialValues(formattedInitialValues);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log('error', error);
    }
  }

  useEffect(() => {
    console.log('action type', actionType)
    if (actionType == formActionTypes.add) {
      console.log('months', monthLabels);
      const monthSet = new Set();
      const labelsValues = [...monthLabels].reduce((prev, curVal) => {
        const momentYear = moment(curVal, "MM-YYYY").format("YYYY");

        if (monthSet.size > 0 && !monthSet.has(momentYear)) {
          prev.push({
            label: curVal,
            value: '',
            apiCosts: 0,
            updatedCosts: 0,
            inEffectValue: MetricValueType.updatedCost,
            isSeparator: true,
            editedBy: null,
            editedByName: null,
            editedTime: null,
            isPercentage: false,
          })
        } else {
          prev.push({
            label: curVal,
            value: '',
            apiCosts: 0,
            updatedCosts: 0,
            inEffectValue: MetricValueType.updatedCost,
            isSeparator: false,
            editedBy: null,
            editedByName: null,
            editedTime: null,
            isPercentage: false,
          })
        }
        monthSet.add(momentYear);
        return prev;
      }, [])
      setInitialValues({
        typeOfAmount: 'fixed',
        months: labelsValues,
        apiAvailable: false,
        integrationPartner: null,
        setForFutureMonths: true,
        isUserAdded: true,
      })
      console.log('labelsValues', labelsValues);
    } else if (actionType == formActionTypes.edit) {
      financeMetricsEditValues();
    }
  }, [actionType, formMetricId]);




  // const parseNumberForDB = (formattedValue) => {
  //     // Parse the formatted number to a float
  //     const numericValue = parseFloat(formattedValue.toString().replace(/,/g, ''));
  //     return isNaN(numericValue) ? 0 : numericValue; // Return 0 or a similar default value if parsing fails
  // };

  const formattedOptions = useMemo(() => {
    // console.log('categoryId', categoryId, categoryName);
    // console.log('financeStatementOptions', financeStatementOptions, financeStatmentId);
    // const allOptions = financeStatementOptions.filter(item => )
    const filteredOption = [];
    // console.log('financeStatement', financeStatementOptions)
    for (const option of financeStatementOptions) {
      if (option?.id != financeStatmentId) {
        filteredOption.push(option);
      }
      if (option?.id == financeStatmentId) {
        if (option?.name == PnlFsNames.sales) {
          filteredOption.push(option);
          // if (option?.subRows && option?.subRows.length) {
          //     option?.subRows.forEach((item) => {
          //         if (!item.isEditable) {
          //             filteredOption.push(item)
          //         }
          //     })
          // }
        }
        break;
      }
    }
    // console.log('filtered Option', filteredOption)
    if (filteredOption.length) {

      const removedMetrics = ['Monthly Growth %', 'Gross Profit %', 'CM1 %', 'CM2 %'];
      const allOptions = filteredOption.reduce((prev, curVal) => {
        if (!curVal?.isTitle && !removedMetrics.includes(curVal?.name)) {
          if (categoryName == PnlCategoryNames.salesChannels) {
            if (curVal.isExpandable && curVal.subRows.length) {
              curVal.subRows.forEach((item, index) => {
                if (!item.isEditable) {
                  prev.push({
                    label: item?.metricName,
                    feLabel: `${item?.metricName} - ${curVal.name}`,
                    value: `${TypeOfFinanceOption.financeMetric}_${item.metricId}`,
                    id: item?.metricId,
                    type: TypeOfFinanceOption.financeMetric
                  })
                }
              })
            }
          } else {
            prev.push({
              label: curVal.name,
              feLabel: curVal.name,
              value: `${TypeOfFinanceOption.financeStatement}_${curVal.id}`,
              id: curVal.id,
              type: TypeOfFinanceOption.financeStatement
            })
            if (curVal.isExpandable && curVal.subRows.length) {
              curVal.subRows.forEach((item, index) => {
                const label = (item?.metricName == 'D2C' && true) ? 'D2C - Total Sales' : item?.metricName
                prev.push({
                  label: label,
                  feLabel: label.includes('-') ? label : `${item?.metricName} - ${curVal.name}`,
                  value: `${TypeOfFinanceOption.financeMetric}_${item.metricId}`,
                  id: item?.metricId,
                  type: TypeOfFinanceOption.financeMetric
                })
              })
            }
          }
        }
        return prev;
      }, []);
      return allOptions;
    } else {
      return []
    }
  }, [financeStatementOptions, financeStatmentId, categoryName]);



  const deleteMetric = async () => {
    try {
      setDeleteBtnLoading(true);
      const data: any = await RestS.deleteMetric(formMetricId);
      if (data?.status) {
        closeForm(true);
      }
    } catch (error) {
      console.log('error');
      closeForm();
    } finally {
      setDeleteBtnLoading(false);
    }
  }

  const sendPnlUpdateGaEvent = (pnlUpdateType) => {
    GASendEvent(user, GAEvents.pnl_update, {
      [GADimensions.userLoginId]: user.id,
      [GADimensions.userType]: user.role,
      [GADimensions.pnl_type]: pnlUpdateType,
      [GADimensions.companyId]: user.companyId,
      [GADimensions.companyName]: user.companyName,
    });
  }

  const submitForm = async (values) => {
    console.log('values', values);
    const formattedCommonValues = {
      fixedAmountValue: parseNumberForDB(values.fixedAmountValue),
      fixedPercentageValue: parseNumberForDB(values.fixedPercentageValue ?? '', true),
    }

    if (actionType == formActionTypes.add) {
      const finalValues = {
        ...values,
        metricId: null,
        categoryId,
        months: values.months.map((item, index) => {
          return {
            ...item,
            monthYear: item.label,
            percentageValue: item.isPercentage ? item.value : null,
            apiCost: parseNumberForDB(item.apiCosts),
            value: parseNumberForDB(item.value),
            updatedCost: item.inEffectValue == MetricValueType.updatedCost ? parseNumberForDB(item.value) : null,
          }
        }),
        ...formattedCommonValues
      }

      // return;
      const insertedData = await RestS.insertInputMetricsData(finalValues);
      if (insertedData) {
        closeForm(true);
        sendPnlUpdateGaEvent('metric_add');
      }
    } else {
      // closeForm();
      // const formValues = {
      //     ...values,
      //     metricId: formMetricId
      // }
      // console.log('coming here')
      const formattedMonthValues = values.months.map((item, index) => {
        const updatedCost = item.inEffectValue == MetricValueType.updatedCost ? parseNumberForDB(item.value) : null;
        console.log('updatedCost', updatedCost)
        return {
          ...item,
          monthYear: item.label,
          percentageValue: item.isPercentage ? parseNumberForDB(item.value, true) : null,
          apiCost: parseNumberForDB(item.apiCost),
          value: parseNumberForDB(item.value, item.isPercentage ? true : false),
          updatedCost: item.isPercentage ? item.updatedCost : item.inEffectValue == MetricValueType.updatedCost ? parseNumberForDB(item.value) : null,
        }
      });
      // console.log('formValues', formValues);
      const finalFormValues = {
        ...values,
        months: formattedMonthValues,
        metricId: formMetricId,
        categoryId,
        ...formattedCommonValues,
      }

      // console.log('edit form values', finalFormValues);
      // return;
      try {
        // setLoading(true);
        const data: any = await RestS.editInputDataMetric(finalFormValues);
        if (data?.status) {
          closeForm();
          sendPnlUpdateGaEvent('metric_update');
        }
      } catch (error) {
        console.log('error', error);

      } finally {
        // setLoading(false);
      }


    }
  }

  const parseToNumber = (event) => {
    const value = event.target.value;
    // Allow numbers and a single decimal point
    if (value === '' || /^[0-9]*\.?[0-9]*$/.test(value)) {
      return value;
    }
  }

  const allowOnlyNumber = (value, isDecimal) => {
    //
    const re = isDecimal ? /^[0-9]*\.?[0-9]*$/ : /^[0-9\b]+$/;

    // if value is not blank, then test the regex

    if (value === "" || re.test(value)) {
      return true;
    } else {
      return false;
    }
  };









  return (
    <>
      <Modal size="md" centered isOpen={isOpen}
        toggle={() => {
          // e.stopProp
          closeForm();
        }}
      >
        <div className={styles.formRootContainer}>
          <div className={styles.headerContainer}>
            <div className={styles.title}>
              {/* {`${actionType == formActionTypes.add ? "Add" : "Update"} ${categoryName}`} */}
              {actionType == formActionTypes.add ? `Add ${categoryName}` : formHeaderTitle?.editTitle}
            </div>
            <div className={styles.actionButtonContainer}>
              {/* {loading ? null :
                                initialValues['isUserAdded'] && actionType != formActionTypes.add ?
                                    // <button className={`${styles.iconBtn} ${styles.deleteBtn}`} onClick={() => setShowDeleteConfirmation(true)}>
                                    //     <AiOutlineDelete />
                                    // </button>
                                    <MeritoButton type="destructive-tint" onClick={() => setShowDeleteConfirmation(true)} onlyIcon={true} icon={<DeleteIcon />} />
                                    : null} */}

              <MeritoButton type="secondary-1" icon={<CloseIcon />} onlyIcon={true} onClick={(e) => {
                e.stopPropagation();
                closeForm();
              }} />
            </div>
          </div>

          {loading ?
            <>
              <div className={styles.loadingContainer}>
                <CircularLoader
                // backgroundColor={
                //     feedFor === InsightFeedFor.goalsHub ? "white" : "#f0eff4"
                // }
                />
              </div>

              <div className={styles.footerContainer}>
                <MeritoButton btnText="Cancel" type="tertiary" onClick={() => { }} />
                <MeritoButton btnText="Add" type="primary-1" onClick={() => { }} />
              </div>
            </>

            : <Form
              initialValues={initialValues}
              mutators={{
                // potentially other mutators could be merged here
                ...arrayMutators,
                setFieldTouched: setFieldTouchedMutator,
              }}
              validate={(values) => {
                // console.log('form values', values);

                if (values.months && values.months.length) {
                  const isValuePresent = values.months.some((item) => (item?.value != null && item?.value != "") || item?.value == 0);
                  if (!isValuePresent) {
                    return {
                      months: values.months.map(() => {
                        return {
                          value: 'Enter a value for at least one month to add this channel.'
                        }
                      })
                    }
                  }
                }
                return {}
              }}
              // debug={(state) => {
              //     console.log('state', state.values)
              // }}
              onSubmit={(values) => {
                // console.log('values', values);
                submitForm(values);
              }} render={({ values, handleSubmit, pristine, hasValidationErrors, form: { change, batch, mutators } }) => {
                // console.log('values', values)
                return (
                  <form onSubmit={handleSubmit}>
                    <div className={styles.formBodyContainer}>
                      <Field
                        name="metricName"
                        validate={(value) => {
                          if (!value) {
                            return `Please enter a title`
                          }
                        }}
                      >
                        {(props) => (
                          <OutlinedFormInput
                            {...props.input}
                            disabled={!values?.isUserAdded}
                            label="Title"
                            name="metricName"
                            value={props.input.value}
                            onChange={props.input.onChange}
                            error={props.meta.error}
                            touched={props.meta.touched}
                            maxLength={70}
                          />

                        )}
                      </Field>

                      <div className={styles.fixedCostsContainer}>
                        <Field name="typeOfAmount" >
                          {(props) => {
                            return (
                              <MeritoRadioButton
                                {...props.input}
                                label="Type of Cost"
                                radioLabels={[
                                  {
                                    label: "Actuals",
                                    value: 'fixed',
                                    disabledState: false
                                  },
                                  {
                                    label: "Percentage of",
                                    value: 'percentage',
                                    disabledState: formattedOptions && formattedOptions.length ? false : true,
                                  },

                                ]}
                                name={props.input.name}
                                value={props.input.value}
                                onChange={props.input.onChange}
                                error={props.meta.error}
                                fieldContainerStyle={{ marginBottom: "0.8rem" }}
                              />

                            )
                          }}
                        </Field>
                        {values?.typeOfAmount == TypeOfAmount.fixed ?
                          <div className={styles.multiApplyContainer}>
                            {/* <div className={styles.valueContainer}> */}
                            <div className={`${styles.inputContainer} ${styles.fixedAmt}`}>
                              <Field
                                name="fixedAmountValue"
                              >
                                {(props) => (
                                  <OutlinedFormInput
                                    {...props.input}
                                    isCurrency={true}
                                    // inpuType={'number'}
                                    name={props.input.name}
                                    onChange={(e) => {
                                      // console.log('e', e.target.value)
                                      const numericValue = parseNumberForDB(e.target.value, true);
                                      props.input.onChange(numericValue);
                                    }}
                                    allowDecimals={true}
                                    value={props.input.value}
                                    error={props.meta.error}
                                    placeholder="Enter Amount"
                                    touched={props.meta.touched}
                                    unitPlaceHolder="₹"
                                    maxLength={21}
                                  />
                                )}
                              </Field>
                            </div>
                            <div className={`${styles.btnContainer} ${styles.fixedAmt}`}>
                              <MeritoButton btnType="button" type="secondary-2" btnText="Apply to All" onClick={() => {
                                if (values?.fixedAmountValue || values?.fixedAmountValue == 0) {
                                  const updatedMonths = values.months.map((item, index) => {
                                    // return {
                                    //     ...item,
                                    //     value: values.fixedAmountValue,
                                    // }
                                    return {
                                      ...item,
                                      inEffectValue: MetricValueType.updatedCost,
                                      editedBy: userId,
                                      editedTime: new Date(),
                                      value: values.fixedAmountValue,
                                      isPercentage: false,
                                    }
                                  })
                                  change('months', updatedMonths);
                                }

                              }} />
                            </div>

                          </div>
                          :
                          <div className={styles.multiApplyContainer}>
                            <div className={styles.valueContainer}>
                              <Field
                                name="fixedPercentageValue"
                              >
                                {(props) => (
                                  <OutlinedFormInput
                                    {...props.input}
                                    inpuType="number"
                                    containerStyles={{ borderTopRightRadius: '0', borderBottomRightRadius: '0', borderRight: "none", padding: "0.52rem 0.75rem" }}
                                    name={props.input.name}
                                    value={props.input.value}
                                    // onChange={props.input.onChange}
                                    onChange={(e) => {
                                      // console.log('value', e.target.value)
                                      const numericValue = parseNumberForDB(e.target.value, true);
                                      props.input.onChange(numericValue);
                                    }}
                                    onBlur={() => {
                                      const value = props.input.value;
                                      const formattedValue = onBlurFormatNumber(value, 2);
                                      props.input.onChange(formattedValue);
                                      props.input.onBlur();
                                    }}
                                    error={props.meta.error}
                                    touched={props.meta.touched}
                                    unitPlaceHolder="% of"
                                    unitPosition="right"
                                    maxLength={10}
                                  />
                                )}
                              </Field>

                              <Field
                                name="selectedMetric"
                                validate={(value) => {
                                  if (!value) {
                                    return "Please select a metric"
                                  }
                                }}
                              >
                                {(props) => (
                                  <SelectMetricCustom value={props.input.value} handleSelectedValue={(value) => {
                                    console.log('selectedMetric', value)
                                    props.input.onChange(value);
                                  }} options={formattedOptions} />
                                )}
                              </Field>


                            </div>
                            <div className={styles.btnContainer}>
                              <MeritoButton btnType="button" type="secondary-2" btnText="Apply to All" onClick={() => {
                                if (values?.selectedMetric) {
                                  const updatedMonths = values.months.map((item, index) => {
                                    return {
                                      ...item,
                                      editedBy: userId,
                                      editedTime: new Date(),
                                      inEffectValue: MetricValueType.updatedCost,
                                      value: values.fixedPercentageValue,
                                      isPercentage: true,
                                    }
                                  })
                                  change('months', updatedMonths);
                                } else {
                                  mutators.setFieldTouched('selectedMetric')
                                }

                              }} />
                            </div>


                          </div>
                        }
                        <div className={styles.checkBoxContainer}>
                          <Field name="setForFutureMonths" >
                            {(props) => {
                              return (
                                <MeritoCheckbox
                                  {...props.input}
                                  disabled={(values?.fixedAmountValue || values?.fixedAmountValue == 0) || (values?.fixedPercentageValue && values?.selectedMetric) ? false : true}
                                  name={props.input.name}
                                  value={props.input.value}
                                  onChange={props.input.onChange}
                                  error={props.meta.error}
                                  touched={props.meta.touched}
                                />
                              )
                            }}
                          </Field>
                          <div className={styles.checkboxLabel} >
                            Set this as a default value for future months
                          </div>
                        </div>
                      </div>

                      <OnChange name="typeOfAmount">
                        {(value, previous) => {
                          // do something
                          if (value == "fixed") {
                            const oldMonthValues = initialValues['months'];
                            const fixedValues = initialValues['months'].map((item, index) => {
                              return {
                                ...item,
                                isPercentage: false,

                                value: item.isPercentage ? '' : item.value,
                                editedBy: item?.editedBy && !item.isPercentage ? item.editedBy : null,
                                editedTime: item?.editedTime && !item.isPercentage ? item.editedTime : null,
                                editedByName: item?.editedByName && !item.isPercentage ? item.editedByName : null,
                              }
                            })
                            batch(() => {
                              change('months', fixedValues);
                            })

                          }
                          if (value == "percentage") {
                            const percentageValues = initialValues['months'].map((item, index) => {
                              return {
                                ...item,
                                isPercentage: true,
                                inEffectValue: MetricValueType.updatedCost,
                                editedBy: percentageIsDirty ? null : item?.editedBy && item.isPercentage ? item.editedBy : null,
                                editedTime: percentageIsDirty ? null : item?.editedTime && item.isPercentage ? item.editedTime : null,
                                editedByName: percentageIsDirty ? null : item?.editedByName && item.isPercentage ? item.editedByName : null,
                                value: percentageIsDirty ? '' : item?.isPercentage ? item.percentageValue : '',
                              }
                            })
                            // console.log('initialValues', initialValues)
                            batch(() => {
                              change("months", percentageValues)
                            })

                          }
                        }}
                      </OnChange>
                      <OnChange name="selectedMetric">
                        {(value, previous) => {
                          // do something
                          // if (value == "fixed") {
                          //     const oldMonthValues = initialValues['months'];
                          //     change('months', oldMonthValues);
                          // }
                          if (value && values?.typeOfAmount == "percentage") {
                            if (!percentageIsDirty) {
                              setPercentageIsDirty(true)
                            }
                            const percentageValues = initialValues['months'].map((item, index) => {
                              return {
                                ...item,
                                isPercentage: true,
                                inEffectValue: MetricValueType.updatedCost,
                                editedBy: null,
                                editedTime: null,
                                value: '',
                              }
                            })
                            change("months", percentageValues)
                          }
                        }}
                      </OnChange>
                      <CategoryFormErrorFieldContainer isCategoryForm={true} />

                      <div className={styles.monthsRootContainer}>

                        <FieldArray name="months">
                          {({ fields }) => (
                            <>
                              {fields.map((name, index) => {
                                const currentMonthValue = values.months[index];
                                // console.log('name', name, currentMonthValue, values.months[index].inEffectValue == MetricValueType.updatedCost && values?.typeOfAmount != "percentage" && (values.months[index]?.value || initialValues["months"][index]?.value) && (values.months[index]?.apiCost != 0 && values.months[index]?.apiCost != '0' && values.months[index]?.apiCost))
                                const undoButton = (
                                  <>
                                    {
                                      values.months[index].inEffectValue == MetricValueType.updatedCost && values?.typeOfAmount != "percentage" && (values.months[index]?.value || initialValues["months"][index]?.value) && (values.months[index]?.apiCost != 0 && values.months[index]?.apiCost != '0' && values.months[index]?.apiCost) ?
                                        <OverlayTrigger
                                          placement="bottom"
                                          delay={{ show: 100, hide: 100 }}
                                          overlay={(props) =>
                                            RenderTooltip(
                                              props,
                                              `Use ${values?.integrationPartner} value`
                                            )
                                          }
                                        >
                                          <button type="button" className={styles.undoBtn} onClick={() => {

                                            batch(() => {
                                              change(`${name}.inEffectValue`, MetricValueType.apiCost);
                                              change(`${name}.value`, currentMonthValue?.apiCost);
                                              change(`${name}.isPercentage`, false)
                                            })
                                          }}>
                                            <UndoIcon />
                                          </button>
                                        </OverlayTrigger>
                                        :
                                        <button type="button" className={`${styles.undoBtn} ${styles.hidden}`}>
                                          <UndoIcon />
                                        </button>
                                    }
                                  </>)
                                return (
                                  <>
                                    {values.months[index].isSeparator ? <div className={styles.separator}></div> : null}

                                    <div className={styles.monthsContainer}>
                                      <div className={styles.leftContainer}>
                                        <div className={styles.monthLabel}>
                                          {`${moment(values.months[index].label, "MM-YYYY").format("MMM YYYY")}`}
                                        </div>
                                        {values.months[index].inEffectValue == MetricValueType.apiCost && values.months[index].value && values?.apiAvailable ? <div className={styles.iconContainer}>
                                          <img src={ipConfigs[values?.integrationPartner]['logo']} />
                                        </div> : actionType == formActionTypes.edit && values.months[index].inEffectValue == MetricValueType.updatedCost && currentMonthValue?.editedBy && (values.months[index].value || initialValues['months'][index].value || values.months[index].value == 0 || initialValues['months'][index].value == 0) ?
                                          <OverlayTrigger
                                            placement="bottom"
                                            delay={{ show: 100, hide: 100 }}
                                            overlay={(props) =>
                                              RenderTooltip(
                                                props,
                                                `Edited by ${currentMonthValue?.editedBy == userId ? 'you' : currentMonthValue?.editedByName}  ${currentMonthValue?.editedTime ? `on ${moment(currentMonthValue?.editedTime).format("MMM DD, YYYY")}` : ''}`
                                              )
                                            }
                                          >
                                            <div className={`${styles.iconContainer}`}>
                                              <LiaUserEditSolid />
                                            </div>
                                          </OverlayTrigger>
                                          : null
                                        }
                                      </div>
                                      <div className={styles.inputFieldContainer}>
                                        <Field
                                          name={`${name}.value`}

                                        // validate={(value) => {
                                        //     if (!value) return "Enter at least one month’s value to Add";
                                        // }}
                                        >
                                          {(props) => (

                                            <OutlinedFormInput
                                              {...props.input}
                                              showError={false}
                                              inpuType="number"
                                              // containerStyles={{ borderTopRightRadius: '0', borderBottomRightRadius: '0', borderRight: "none", padding: "0.52rem 0.75rem" }}
                                              name={props.input.name}
                                              // value={values?.months[index].isPercentage ? props.input.value : formatNumberWithComma(props.input.value)}
                                              value={props.input.value}

                                              allowDecimals={true}
                                              onChange={(e) => {
                                                // console.log('value', e.target.value)
                                                const numericValue = parseNumberForDB(e.target.value, true);
                                                console.log('numeric value', numericValue)
                                                props.input.onChange(numericValue);
                                              }}
                                              error={props.meta.error}
                                              touched={props.meta.touched}
                                              onBlur={(e) => {

                                                // console.log('onBlur triggering')
                                                // if (currentMonthValue?.inEffectValue == MetricValueType.updatedCost && currentMonthValue?.updatedCost && currentMonthValue?.apiCost) {
                                                const value = props.input.value;
                                                console.log('value', value);
                                                // console.log('value', value);
                                                const formattedValue = onBlurFormatNumber(value, 2);
                                                // console.log('formattedValue', formattedValue);
                                                props.input.onChange(formattedValue);
                                                console.log('inputValue', value)
                                                if (props.input.value != currentMonthValue?.apiCost) {
                                                  batch(() => {
                                                    change(`${name}.inEffectValue`, MetricValueType.updatedCost);
                                                    change(`${name}.editedBy`, userId);
                                                    change(`${name}.editedTime`, new Date());
                                                  })
                                                }
                                                props.input.onBlur(e);
                                              }}
                                              unitPlaceHolder={currentMonthValue?.isPercentage && currentMonthValue?.inEffectValue != MetricValueType.apiCost ? "%" : '₹'}
                                              unitPosition={currentMonthValue?.isPercentage && currentMonthValue?.inEffectValue != MetricValueType.apiCost ? "right" : null}
                                              buttonEle={!values?.months[index].isPercentage ? undoButton : null}
                                              maxLength={values?.months[index].isPercentage ? 10 : 21}
                                              isCurrency={values?.months[index].isPercentage ? false : true}
                                            />
                                          )}
                                        </Field>


                                      </div>
                                    </div>
                                  </>

                                )
                              })
                              }
                            </>
                          )}
                        </FieldArray>
                      </div>


                      {/* <div style={{ height: '100px' }}>
                                            test container
                                        </div> */}
                    </div>

                    <div className={styles.footerContainer}>
                      <div className={styles.leftContainer}>
                        {initialValues['isUserAdded'] && actionType != formActionTypes.add ?
                          <MeritoButton btnText={'Delete'} type="destructive-ghost" onClick={() => setShowDeleteConfirmation(true)} onlyIcon={true} icon={<DeleteIcon />} />
                          : null}
                      </div>
                      <div className={styles.rightContainer}>
                        <MeritoButton btnText="Cancel" type="tertiary" onClick={() => closeForm()} />
                        <MeritoButton disabled={pristine || hasValidationErrors} btnText={actionType == formActionTypes.edit ? "Update" : "Add"} type="primary-1" onClick={() => {
                          handleSubmit();
                        }} />
                      </div>

                    </div>


                    <ConfirmDialog
                      // bodyStyle={{ padding: "" }}
                      modalStyles={{ maxWidth: '450px' }}
                      showButton={false}
                      visible={showDeleteConfirmation}
                      // visible={true}
                      // visible={connectionId}
                      toggle={() => {
                        setShowDeleteConfirmation(!showDeleteConfirmation);
                      }}
                      // onClick={() =>
                      //   progress > 100 ? setProgress(0) : setProgress(progress + 1)
                      // }
                      showCloseBtn={false}
                      size={"md"}
                    >
                      <div className={styles.confirmationContainer}>
                        <div className={styles.topContainer}>
                          <div className={styles.iconContainer}>
                            <Exclamation />
                          </div>
                          <div className={styles.title}>
                            Are You Sure You Want to Delete?
                            {/* ‘{`${categoryName} - ${values?.metricName}`}’? */}
                          </div>
                          {/* <div className={styles.subTitle}>
                                                        
                                                    </div> */}

                          <div className={styles.warningContainer}>
                            <div className={styles.warningText}>
                              This will impact the numbers from the last 12 months.
                            </div>
                          </div>
                        </div>

                        <div className={styles.bottomContainer}>
                          <MeritoButton onClick={() => setShowDeleteConfirmation(!showDeleteConfirmation)} size="lg" isRounded={true} btnType="button" type="secondary-2" btnText="Cancel" />
                          <MeritoButton loading={deleteBtnLoading} size="lg" onClick={deleteMetric} isRounded={true} btnType="button" type="primary-1" btnText="Delete" />
                        </div>
                      </div>
                    </ConfirmDialog>
                  </form>


                )


              }} />
          }




        </div>
      </Modal>


    </>
  );
}

export default CategoryForm;